export const maxAssetsToDisplay = 50;
export const maxAssetsInView = 4;
